import { AlertTriangle, CheckCircle2, CircleDashed, Loader } from "lucide-react";

const CARDS = [
  { key: "Open", label: "Open", icon: CircleDashed, tone: "metric-gray" },
  { key: "In progress", label: "In progress", icon: Loader, tone: "metric-amber" },
  { key: "Filled", label: "Filled", icon: CheckCircle2, tone: "metric-green" },
  { key: "attention", label: "Needs attention", icon: AlertTriangle, tone: "metric-attention", hint: "No client, recruiter, or candidate" },
];

export const BoardMetricCards = ({ active, counts, onSelect }) => (
  <section className="board-metric-grid" data-testid="board-metric-cards">
    {CARDS.map((card) => {
      const Icon = card.icon;
      const isActive = active === card.key;
      const slug = card.label.toLowerCase().replaceAll(" ", "-");
      return (
        <button
          aria-pressed={isActive}
          className={`board-metric ${card.tone} ${isActive ? "board-metric-active" : ""}`}
          data-testid={`metric-card-${slug}`}
          key={card.key}
          title={card.hint}
          type="button"
          onClick={() => onSelect(isActive ? "" : card.key)}
        >
          <span className="board-metric-icon"><Icon size={16} /></span>
          <strong data-testid={`metric-count-${slug}`}>{counts[card.key] ?? 0}</strong>
          <small>{card.label}</small>
        </button>
      );
    })}
  </section>
);
